import { isBE } from '@/react/portainer/feature-flags/feature-flags.service';
import { useWhiteLabel } from '@/react/portainer/feature-flags/useWhiteLabel';

import { ContextHelp } from '@@/PageHeader/ContextHelp';

import { useHeaderContext } from './HeaderContainer';
import { NotificationsMenu } from './NotificationsMenu';
import { UserMenu } from './UserMenu';
import { AskAILink } from './AskAILink';

export function HeaderTitle() {
  useHeaderContext();
  const { data: whitelabel } = useWhiteLabel();

  return (
    <div className="flex items-center">
      {isBE && !whitelabel && <AskAILink />}
      <NotificationsMenu />
      {!whitelabel && <ContextHelp />}
      {!window.ddExtension && <UserMenu />}
    </div>
  );
}
